<!-- 游玩攻略详情 -->
<template>
  <div class="frame">
    <div class="banner">
      <div class="bg"></div>
    </div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">{{ $t("common.home") }}</el-breadcrumb-item>
        <el-breadcrumb-item to="/strategy">{{
          $t("nav.strategy")
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ detail.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="wrap">
      <div class="contain">
        <div class="title">{{ detail.title }}</div>
        <div class="time">{{ $t("common.publishedAt") }}{{ detail.time }}</div>
        <div class="content" v-html="detail.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStrategyById } from "../utils/localeContent";

export default {
  data() {
    return {
      detail: {},
    };
  },
  watch: {
    "$route.query.id"() {
      this.loadDetail();
    },
    "$i18n.locale"() {
      this.loadDetail();
    },
  },
  created() {
    this.loadDetail();
  },
  methods: {
    loadDetail() {
      if (this.$route.query.id) {
        this.detail = getStrategyById(
          this.$route.query.id,
          this.$i18n.locale
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  height: 450px;
  position: relative;

  &::after {
    content: "";
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.5);
    position: absolute;
    left: 0;
    top: 0;
  }

  .bg {
    width: 100%;
    height: 100%;
    background-image: url("../assets/source/strategy_banner.jpg");
    background-size: cover;
    background-position: center bottom;
  }
}

.breadcrumb {
  padding: 20px 0;
  border-bottom: 1px solid #ddd;

  .el-breadcrumb {
    width: 1200px;
    margin: 0 auto;
  }
}

.wrap {
  padding: 30px 0;

  .contain {
    width: 1200px;
    margin: 0 auto;

    .title {
      font-size: 25px;
      font-weight: bold;
      text-align: center;
    }
    .time {
      font-size: 14px;
      padding: 10px 0;
      color: #adadad;
      border-bottom: 1px solid #ddd;
      text-align: center;
    }
    .content {
      padding: 20px 0;
      line-height: 1.5;

      :deep(img) {
        max-width: 100%;
        height: auto;
      }
    }
  }
}
</style>
